<template>
    <button id="ExploreButton" @click="openContact" aria-label="back" class="btnfx btnfx__clickflash">
        <IconGlobe></IconGlobe>
        <span>Explore</span>
    </button>
</template>
<script>
export default {
    methods: {
        openContact() {
             app.api.PageManager.openContentComponentFromID(2374);
        }
    },
    computed: {
        onHomePage() {
            this.$route;
            return app.api.PageManager.onHomePage()
        }
    }
}
</script>
<style lang="scss" scoped>
#ExploreButton {
    right: 80px;
    top: 80px;
    display: flex;

    img {
        width: 24px;
    }

   
}
</style>